import type { ComponentPropsWithoutRef, ReactNode, RefObject } from 'react'
import type {
  ScrollView,
  ScrollViewProps,
  StyleProp,
  ViewStyle,
} from 'react-native'
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView as RNScrollView,
  View,
} from 'react-native'

type KeyboardAwareScrollLayoutProps = {
  children: ReactNode
  footer?: ReactNode
  footerStyle?: StyleProp<ViewStyle>
  contentContainerStyle?: ScrollViewProps['contentContainerStyle']
  contentContainerClassName?: string
  className?: string
  scrollViewRef?: RefObject<ScrollView | null>
} & Omit<
  ComponentPropsWithoutRef<typeof RNScrollView>,
  | 'children'
  | 'contentContainerStyle'
  | 'contentContainerClassName'
  | 'keyboardShouldPersistTaps'
  | 'keyboardDismissMode'
  | 'showsVerticalScrollIndicator'
  | 'ref'
  | 'scrollViewRef'
>

export function KeyboardAwareScrollLayout({
  children,
  footer,
  footerStyle,
  contentContainerStyle,
  contentContainerClassName,
  className,
  scrollViewRef,
  ...scrollViewProps
}: KeyboardAwareScrollLayoutProps) {
  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      className={className}
    >
      <RNScrollView
        ref={scrollViewRef}
        style={{ flex: 1 }}
        keyboardShouldPersistTaps="handled"
        keyboardDismissMode={Platform.OS === 'ios' ? 'interactive' : 'on-drag'}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={contentContainerStyle}
        contentContainerClassName={contentContainerClassName}
        {...scrollViewProps}
      >
        {children}
      </RNScrollView>
      {footer != null ? <View style={footerStyle}>{footer}</View> : null}
    </KeyboardAvoidingView>
  )
}
